import React from 'react';

import PropTypes from 'prop-types';

export const Categories = (props) => {
    const { categories } = props;

    return (
        <span>
            {categories.map((category) => category.name).join(', ')}
        </span>
    );
};

Categories.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
    })).isRequired,
};
